import { __extends } from "tslib";
import { ListJourneysRequest, ListJourneysResponse } from "../models/models_1";
import { deserializeAws_restJson1ListJourneysCommand, serializeAws_restJson1ListJourneysCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListJourneysCommand = /** @class */ (function (_super) {
    __extends(ListJourneysCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListJourneysCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListJourneysCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "ListJourneysCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ListJourneysRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListJourneysResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListJourneysCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1ListJourneysCommand(input, context);
    };
    ListJourneysCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1ListJourneysCommand(output, context);
    };
    return ListJourneysCommand;
}($Command));
export { ListJourneysCommand };
//# sourceMappingURL=ListJourneysCommand.js.map